import { createContext, useContext } from 'react'
import type { PlatformService } from './types'

export const PlatformContext = createContext<PlatformService | null>(null)

/**
 * Хук доступа к PlatformService (абстракция Telegram SDK / Web API).
 * Должен вызываться внутри PlatformProvider.
 * @returns Текущая реализация PlatformService (Telegram или Web)
 */
export const usePlatform = (): PlatformService => {
  const ctx = useContext(PlatformContext)
  if (!ctx) throw new Error('usePlatform must be used within PlatformProvider')
  return ctx
}
